export default "__VITE_ASSET__0ArKMJrn__"